import React from 'react';
import { Virtuoso } from 'react-virtuoso';
import { MCText, SearchTextField, Spinner, View } from 'src/components/basic';
import { remCss, remFontCss } from 'src/components/mobile/utils';
import { CategoriesHorizontal } from 'src/components/mobile/Categories';
import ShortInfo from 'src/components/user/ShortInfo';
import { ActivityLabel } from 'src/components/user/LastActivity';

import { lang, userFullName } from 'src/helpers';
import LANG_CONST from 'src/helpers/lang/const';

import { CHANGE_MOBILE_PAGES_EVENT_ID, MOBILE_PAGES } from '../utils';
import doctorsModel from '../doctorsModel';
import constants from 'src/constants';

const Item = ({ item, onDoctorItem }) => {
  return (
    <View
      style={{
        backgroundColor: 'white',
        paddingVertical: remCss(15),
        paddingHorizontal: remCss(20),
        flexDirection: 'row',
        gap: remCss(10),
        alignItems: 'center',
        cursor: 'pointer'
      }}
      onClick={() => {
        onDoctorItem(item);
      }}
    >
      <ShortInfo
        user={item}
        isDisabledAccount={item.status === constants.general.userStatus.disabled}
        fullname={userFullName(item, item.isDoctor)}
        width={remCss(60)}
        onlineState={item.connections > 0 ? 'online' : ''}
        note={
          <MCText size={18} remFontCss={remFontCss} numberOfLines={1} weight={400} primary>
            <ActivityLabel
              accountState={item.accountState}
              lastActivity={item.lastActivity}
              connections={item.connections}
            />
          </MCText>
        }
      />
    </View>
  );
};

export const DoctorsTab = ({ clinic, onDoctorItem }) => {
  const [searching, setSearching] = React.useState(false);
  doctorsModel.use();

  const items = doctorsModel.items();
  const loading = doctorsModel.refreshing();
  const searchQuery = doctorsModel.listInput('search');
  const noResults = doctorsModel.noResults();

  return (
    <View style={{ flex: 1 }}>
      <Virtuoso
        data={items}
        style={{ backgroundColor: 'white' }}
        components={{
          Header: () => (
            <>
              {!!clinic.doctorsSpecialist?.length && (
                <CategoriesHorizontal
                  onViewAll={() => {
                    doctorsModel.emit(CHANGE_MOBILE_PAGES_EVENT_ID, MOBILE_PAGES.CATEGORIES);
                  }}
                  specialist={clinic.doctorsSpecialist}
                  onSelect={(selected) => {
                    doctorsModel.onChangeSpecialist(
                      doctorsModel.state.specialist === selected ? null : selected
                    );
                  }}
                  selected={[doctorsModel.state.specialist]}
                />
              )}
              <View style={{ padding: remCss(15) }}>
                <SearchTextField
                  template={'2'}
                  placeholder={'Search'}
                  autoFocus={searching}
                  onChange={(v) => {
                    setSearching(true);
                    doctorsModel.handleChangeSearch(v);
                  }}
                  onBlur={() => {
                    setTimeout(() => {
                      setSearching(false);
                    }, 150);
                  }}
                  value={searchQuery}
                />
                {(noResults || loading) && (
                  <>
                    {noResults && !searchQuery && (
                      <div style={{ textAlign: 'center', padding: '1rem' }}>
                        {lang.t(LANG_CONST.text.no_results_yet)}
                      </div>
                    )}
                    {noResults && searchQuery && (
                      <div style={{ textAlign: 'center', padding: '1rem' }}>
                        {lang.t(LANG_CONST.text.nothing_found)}
                      </div>
                    )}
                  </>
                )}
              </View>
            </>
          ),
          Footer: () => (
            <div style={{ textAlign: 'center', paddingBottom: 20, flex: 1 }}>
              {loading && <Spinner />}
            </div>
          )
        }}
        endReached={() => {
          if (doctorsModel.hasMore() && !doctorsModel.refreshing()) doctorsModel.loadMore();
        }}
        itemContent={(index, item) => (
          <Item item={item} index={index} onDoctorItem={onDoctorItem} />
        )}
      />
    </View>
  );
};
